import { Pipe, PipeTransform } from '@angular/core';
import { Filter } from '../models';

@Pipe({ name: 'filterValueOptions' })
export class FilterValueOptionsPipe implements PipeTransform {
  async transform(filter: Filter, search: string): Promise<any[]> {
    return filter.getValueOptions(search);
  }
}
